import { useRouter } from "lib/router";
import { useLayoutEffect } from "react";

const PREV_PATH = "prevPath";
const CURRENT_PATH = "currentPath";

export const useSetReferrer = (): void => {
  const { beforeUnload } = useRouter();

  useLayoutEffect(() => {
    const storage = window.sessionStorage;

    const handleRouteChange = (url) => {
      if (!storage) return true;
      const prevPath = storage.getItem(CURRENT_PATH) || "/";
      storage.setItem(PREV_PATH, prevPath);
      storage.setItem(CURRENT_PATH, url);
    };

    beforeUnload(handleRouteChange);

    const prevPath = storage.getItem(CURRENT_PATH) ?? "/";
    storage.setItem(PREV_PATH, prevPath);
    storage.setItem(CURRENT_PATH, window.location.pathname);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
